var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4B5563",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M1.063 6.27h11.882M9.962 8.874h.006M7.005 8.874h.006M4.04 8.874h.006M9.962 11.466h.006M7.005 11.466h.006M4.04 11.466h.006M9.696 1.334v2.194M4.309 1.334v2.194"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4B5563",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M9.826 2.387H4.18C2.223 2.387 1 3.477 1 5.482v6.033c0 2.036 1.223 3.152 3.18 3.152h5.64c1.963 0 3.18-1.097 3.18-3.101V5.482c.006-2.005-1.21-3.095-3.174-3.095Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar1);
export default __webpack_public_path__ + "static/media/calendar1.f69bbb61c0d39b6b95b07e67b0d90764.svg";
export { ForwardRef as ReactComponent };